export default "__VITE_ASSET__a7117ed1__"